import Loader from '../components/Loader';
import { useEffect, useState } from "react";
import Header from '../components/headerfooter/Header';
import Footer from '../components/headerfooter/Footer';
import MobileFooter from '../components/MobileFooter';
import CallToAction from '../components/home/CallToAction';
import { useNavigate, useParams } from 'react-router';
import { getDecryptedData, removeStoredData } from '../config/crypto';
import { IMAGE_URL, REACT_APP_API_PORT } from '../Api';
import axios from 'axios';
import RazorpayPayment from '../components/RazorpayPayment';
export default function PaidCourseEnrollment(props) {
    const navigate = useNavigate()
    const { id } = useParams()
    const [data, setData] = useState([])
    const [isLoading, setisLoading] = useState(false);
 
    const user = getDecryptedData("user")

    const getData = async () => {
        try {
            setisLoading(true);
            const res = await axios.get(
                `${REACT_APP_API_PORT}user/course/course-details/${id}`, {
                headers: {
                    'Content-Type': 'application/json',
                }
            }
            );
            setisLoading(false);
            if (res.data.status) {
                setData(res.data.data);
            }

        } catch (err) {
            setisLoading(false);
            console.log(err);
        }
    };


    useEffect(() => {
        getData()
    }, []);

    const handleSuccess = async (response) => {
        console.log("Payment Success:", response);
       
        try {
            const token = getDecryptedData("token")
            const coid = getDecryptedData("COID")
            
            setisLoading(true);
            const res2 = await axios.post(
                `${REACT_APP_API_PORT}user/course/order/save-user-course-payment`, {
                    razorpay_order_id:response?.razorpay_order_id,
                    razorpay_payment_id:response?.razorpay_payment_id,
                    razorpay_signature:response?.razorpay_signature,
                    course_order_id:coid
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                        "x-access-token": token,
                    },
                }
            );
            setisLoading(false);
            if (res2.data.status) {
                props.setAlertBox(true);
                props.showAlert("Course purchased successfully", "success");
                removeStoredData("COID")
                navigate('/my-profile');
            }
        } catch (err) {
            setisLoading(false);
            console.log(err)
            if (err.response?.data?.status === false) {
                props.setAlertBox(true);
                props.showAlert(err.response.data.message, "error");
            }
        }
    };

    const handleFailure = (response) => {
        // console.log("Payment Failed:", response);
        props.setAlertBox(true);
        props.showAlert("Payment Failed, Try again later!", "error");
    };
    return (
        <>
            <Loader isLoading={isLoading} />
            {/* <TopBar /> */}
            <Header />
            <div className="flex flex-col md:flex-row items-center justify-center min-h-screen p-4">
                {/* Left Section */}
                <div className="w-full md:w-1/2  p-2 lg:p-6 rounded-lg max-w-lg">
                    <img
                        src={data?.banner ? IMAGE_URL + data?.banner : '/images/placeholder-image.png'}
                        alt="Course Thumbnail"
                        className="w-full h-64 object-fit:cover border"
                    />

                    <span className="block text-2xl font-bold mt-4 mb-2 text-[#36394D]">{data?.course_name}</span>
                    <span className="text-black my-3 text-[#36394D]">
                        {
                            (data?.section1_description) ?
                                <p className="text-lg  max-w-3xl mb-6 leading-none">
                                    <div dangerouslySetInnerHTML={{ __html: data?.section1_description }} />
                                </p>
                                :
                                <p className="text-lg text-center max-w-3xl mb-6 leading-none">
                                    Course description is not available
                                </p>
                        }
                     
                    </span>

                    <div className='flex justify-between my-3'>
                        <div>
                            <span className="text-lg font-semibold mt-2  text-[#36394D]">{data?.payment_type}</span>

                        </div>
                        <div>
                            <span className="text-lg font-semibold mt-2  text-[#36394D]">{data?.payment_type === "Paid" ? `₹ ${data?.amount}` : "₹ 0.00"}</span>

                        </div>
                    </div>
                    <hr className='text-gray-300'></hr>
                </div>

                <div className="hidden md:block h-96 border-l border-gray-100 mx-6"></div>

                {/* Right Section */}
                {
                    (user) &&
                    <div className='w-full md:w-1/2  p-2 lg:p-6 rounded-lg max-w-lg'>
                        <div>
                            <h2 className="text-2xl font-bold text-gray-800 text-center mb-4  text-[#36394D] ">
                                Your Account
                            </h2>
                            <div className="bg-gray-100 p-4 rounded-lg">
                                <p className="text-gray-700 text-lg">
                                    <span className="font-medium">Name:</span> {user.name}
                                </p>
                                <p className="text-gray-700 text-lg mt-1">
                                    <span className="font-medium">Email:</span> {user.email}
                                </p>
                                <p className="text-gray-700 text-lg mt-1">
                                    <span className="font-medium">Course:</span> {data?.course_name}
                                </p>
                                <p className="text-gray-700 text-lg mt-1">
                                    <span className="font-medium">Amount:</span> ₹ {data?.amount}
                                </p>
                            </div>

                        </div>
                      
                        <RazorpayPayment
                            amount={data?.amount}
                            name={user?.name}
                            email={user?.email}
                            id={id}
                            onSuccess={handleSuccess}
                            onFailure={handleFailure}
                        />
                    </div>

                }
            </div>
            <CallToAction />
            <Footer />
            <MobileFooter />
        </>
    );
}
